<template>
  <div class="w-full flex items-start flex-col gap-3">
    <div class="w-full flex-y-center justify-between gap-1">
      <div>
        <div class="flex-y-center gap-2">
          <div
            class="plan-icon w-8 h-8 flex-y-center justify-center"
            v-html="user?.plan?.svg_icon"
          ></div>
          <div>
            <p class="text-xs text-gray-450">
              {{ $t("current_plan") }}
            </p>
            <div class="text-left" v-if="user.plan">
              <div v-if="user?.is_stop_buy">
                <p class="text-yellow font-bold">{{ $t("is_stopped_by") }}</p>
              </div>
              <div v-else>
                <div v-if="checkTermTariffPlans > 0 || user?.plan">
                  <p
                    class="text-sm leading-130 font-semibold uppercase"
                    :class="initialDays <= 0 ? 'text-red' : 'text-dark-100'"
                  >
                    {{ user.plan?.title ? user.plan?.title : $t("not_tariff") }}
                  </p>
                </div>
                <p
                  v-else
                  class="text-sm leading-130 font-semibold uppercase text-red"
                >
                  {{ $t("expired_term") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="user?.plan?.title && !user?.plan?.is_free"
        class="flex flex-col items-end"
      >
        <p class="text-xs !leading-normal text-gray-450">
          {{ $t("left_plan") }}
        </p>
        <div>
          <p
            v-if="checkTermTariffPlans > 0"
            class="text-sm !leading-normal font-semibold"
          >
            {{ checkTermTariffPlans }} {{ initialDays }}
          </p>
          <p v-else class="text-base !leading-normal font-semibold text-red">
            {{ $t("expired") }}
          </p>
        </div>
      </div>
    </div>
    <template v-if="user?.is_stop_buy">
      <CButton
        variant="dark"
        class="!rounded-xl"
        :text="$t('activate')"
        :loading="loading"
        :disabled="loading"
        @click="checkUserStopReason"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from "vue";
import { useAuthStore } from "@/modules/Auth/stores";
import { useI18n } from "vue-i18n";
import CButton from "@/components/Common/CButton.vue";

interface Props {
  loading: boolean;
}
defineProps<Props>();
const emit = defineEmits<{
  (e: "handleCheckUserStopReason"): void;
}>();

const { t } = useI18n();

const store = useAuthStore();

const initialDays = ref(t("day_term"));

const user = computed(() => store.user);
const checkTermTariffPlans = computed(() => {
  const { days, hours, minutes } = user.value?.plan_left_days || {};

  return days > 0 ? days : hours > 0 ? hours : minutes;
});

const checkUserStopReason = () => {
  emit("handleCheckUserStopReason");
};

const checkInitialDays = () => {
  if (user.value?.plan_left_days?.days > 0) {
    initialDays.value = t("day_term");
  } else if (user.value?.plan_left_days?.hours > 0) {
    initialDays.value = t("hours_term");
  } else {
    initialDays.value = t("minutes_term");
  }

  return initialDays.value;
};

onMounted(() => {
  checkInitialDays();
});
watch(
  () => user.value?.plan_left_days?.days,
  () => {
    checkInitialDays();
  },
);
</script>

<style scoped>
.custom-gradient {
  background: linear-gradient(
    to right,
    rgba(0, 113, 173, 0.25) 0%,
    rgba(0, 150, 118, 0.25) 100%
  );
}
.plan-icon svg {
  width: 36px;
  height: 36px;
}
.plan-icon svg g path {
  fill: #080a15 !important;
  stroke: #080a15 !important;
}
.plan-icon svg g,
.plan-icon svg {
  stroke: #080a15 !important;
  fill: #080a15 !important;
}
.buy-tariff {
  border: 2px solid rgba(22, 204, 83, 0.3);
  background: linear-gradient(180deg, #000 -9.68%, #031a0a 88.33%);
  box-shadow: 0px 0px 30px 0px rgba(56, 71, 109, 0.09);
}
</style>
